var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bmsg"}},[_c('div',{staticStyle:{"color":"#d0c896"}},[_vm._v("泰安市泰山景区智控信息技术工作室")]),_vm._v(" ©2023 泰山智控 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("鲁ICP备2023029980号")])])
}]

export { render, staticRenderFns }